<template>
  <div>
    <br />
    <h2 class="ViewHeading">Service</h2>

    <b-card> <ClientService> </ClientService> </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import ClientService from "../components/ServiceClient.vue";
export default {
  computed: {},
  components: { ClientService },

  data() {
    return {
      file: "",
      DeviceID: "123456789",
      Folder: "attachments",
      items: [],
      UserHeaders: [],
      response: null,
      ArrTest: [],
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      item0: "",
      item1: "",
      item2: "",
      item3: "",
      item4: "",
      showOverlay: false,
      duplicatefile: false,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      UserProfile: localStorage.getItem("profileportal"),
      UserAccess: localStorage.getItem("accessGroup"),
    };
  },

  beforeMount() {
    Vue.prototype.$RaisedFrom = "Client Service Request Form";
    Vue.prototype.$RaisedFromID = "N/A";
  },

  mounted() {},

  methods: {
    getUserInitials() {
      this.userInitials = localStorage.getItem("UserInitials");
      return this.userInitials;
    },
    userfullname() {
      this.userfullname = localStorage.getItem("fullname");
      return this.userfullname;
    },

    isExist: function() {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i][3] == this.file.name) {
          this.duplicatefile = true;
          return true;
        }
      }
      this.duplicatefile = false;
      return false;
    },

    cancelChooseFile() {
      alert("File Upload Cancelled");
      this.file = "";
      document.getElementById("file-upload").value = null;
    },

    //async onRemoveFile(event) {
    //let url = "attachments" + '/' + event.file.name // event.file.name has only the name after the slash / so the actual filename
    //const res = await deleteObjectByKey(url)
    // if (
    //  res.$response.httpResponse.statusCode >= 200 &&
    //  res.$response.httpResponse.statusCode < 300
    // ){
    // here remove data from database too
    //  }
    // },

    submitFileToDB(FileSave, FileLocation) {
      this.SubmitUserURN = this.$UserURN;
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;

      this.LookUpRequest = {
        RequestType: "Create",
        RequestVariable: "",
        DataDict: [
          {
            DeviceID: this.DeviceID,
            FileName: FileSave,
            FileURL: FileLocation,
            UploaderURN: this.SubmitUserURN,
          },
        ],
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          this.refreshTable();
        });
    },

    showActionModal(var0, var1, var2, var3, var4) {
      this.item0 = var0;
      this.item1 = var1;
      this.item2 = var2;
      this.item3 = var3;
      this.item4 = var4;
      this.$refs["DeviceAttachModal"].show(
        this.item0,
        this.item1,
        this.item2,
        this.item3,
        this.item4
      );
    },
  },
};
</script>

<style>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid cadetblue;
  border-radius: 5px;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  color: cadetblue;
}

#Table {
  margin: auto;
  text-align: center;
}

#cancel-label {
  color: white;
  font-size: large;
}

.Upload label {
  font-size: 15px;
}

.modal {
  text-align: center;
}
</style>
